import React, { Component, Fragment } from 'react';
import className from 'classnames';
import { Link } from 'react-router-dom';
import { ReactComponent as HomeIcon } from './icons/home.svg';
import { ReactComponent as ListIcon } from './icons/list.svg';
import { getCompanyType, deleteToken, getIsSettingsVisible, getIsApprover, setCookie, getUser } from 'Utils/storage';
import { SEEKER_VALUE, SHOW_SIDEBAR, MODULE_ERROR_ACCESS, HIKAL, DEEPAK_PHENOLICS, GREEN_PLY, PROVIDER_VALUE, EMAMI, CARGIL, BEAM, PANTALOONS, TTBIL, ABFRL, DEEPAK_PHENOLICS_SAP, VISHAKA, CONTRACTING_MODULE_ID } from 'Constants/commonConstants';
import { //ACCOUNTS_URL, INDENT_URL,
        LCL_URL, SEEKER_ACCOUNTS_URL, PROVIDER_ACCOUNTS_URL, SEEKER_INDENT_URL, PROVIDER_INDENT_URL, logOutWithToken } from 'Utils/api';
import ReactTooltip from 'react-tooltip';
import { isAdaniWilmar } from 'Utils/';
import { getItemFromLocal } from 'Utils/localStorage';
import { withRouter } from 'react-router';
import { isBeamS, isCoromandel, isDesmet, isDesmetSupplier, isEmami } from 'Utils/index';
import SiderBarElementT1 from './SiderBarElementT1';
import { SAVE_USER_REPORT_UTILIZATION_EVENT, GET_COMPANY_DATA, GET_DAAI_CONFIG } from 'Constants/actionConstants';
import { connect } from 'react-redux';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.user = getUser();
        this.state = {
            openSourcing: this.user.contracting ? true : false,
            openContracting: false,
            openIndenting: false,
            openSettings: false,
            openReports: false,
            openDashboards: false,
            openApprovals: false,
            openUploadPlan: false,
            companyData: null,
            DaaiReports: [],
            daaiReportsLoading: false,
            daaiDashboards: [],

        }
        this.collapseToggle = this.collapseToggle.bind(this);
    }

    componentDidMount() {
        this.getCompanyData();
    }

    getCompanyData = () => {
        const { dispatch } = this.props;
        const isSeeker = getCompanyType() === SEEKER_VALUE;
        const seekerCompanyId = isSeeker
            ? this.user.companyId
            : getItemFromLocal('transporter_seeker_company_id');

        this.setState({ daaiReportsLoading: true });

        dispatch({
            type: GET_COMPANY_DATA,
            isSeeker,
            params: {
                module: 'Contracting',
                module_id: CONTRACTING_MODULE_ID,
                companyId: this.user.companyId,
                seekerCompanyId,
            },
            onSuccess: (responseData) => {
                this.setState({
                    daaiReportsLoading: false,
                    DaaiReports: (responseData && responseData.reports) || [],
                    daaiDashboards: (responseData && responseData.dashboards) || []
                });
            },
            onError: () => {
                this.setState({ daaiReportsLoading: false, DaaiReports: [], daaiDashboards: [] });
            }
        });
    }

    collapseToggle(which) {
        if (which == "contracting" && this.user.contracting) {
            this.setState({ openContracting: !this.state.openContracting });
        } else if (which === 'indenting' && this.user.indenting) {
            this.setState({ openIndenting: !this.state.openIndenting });
        } else if (which === 'settings' && this.user.contracting) {
            this.setState({ openSettings: !this.state.openSettings });
        } else if (which === 'sourcing' && this.user.contracting) {
            this.setState({ openSourcing: !this.state.openSourcing });
        } else if (which === 'reports') {
            this.setState({ openReports: !this.state.openReports });
        } else if (which === 'dashboards') {
            this.setState({ openDashboards: !this.state.openDashboards });
        } else if (which === 'approval') {
            this.setState({ openApprovals: !this.state.openApprovals });
        } else if (which === 'uploadPlan') {
            this.setState({ openUploadPlan: !this.state.openUploadPlan });
        }
    }
    logout = () => {
        // deleteToken();
        //localStorage.setItem('termsAndConditionsAccepted', false);
        // location.href="/";
        logOutWithToken();
    }
    handleAccountsRedirect = (type) => {
        const hostName = window.location.hostname;
        const companyType = getCompanyType();

        const USER_PERMISSIONS = { accounts: this.user.accounts, indents: this.user.indenting };
        if (!USER_PERMISSIONS[type]) return;

        // CIL path — *.sclenai.coromandel.biz always redirects within that domain
        if (hostName.endsWith('sclenai.coromandel.biz')) {
            const CIL_MODULE_SUBDOMAINS = { accounts: 'accounts', indents: 'indenting' };
            const subdomain = CIL_MODULE_SUBDOMAINS[type];
            if (subdomain) {
                const base = hostName.endsWith('beta.sclenai.coromandel.biz')
                    ? 'beta.sclenai.coromandel.biz'
                    : 'sclenai.coromandel.biz';
                localStorage.setItem('teg-component', true);
                location.href = `https://${subdomain}.${base}`;
            }
            return;
        }

        // SCLEN path — *.transporteg.com always redirects within that domain
        const SCLEN_URLS = {
            accounts: companyType === SEEKER_VALUE ? SEEKER_ACCOUNTS_URL : PROVIDER_ACCOUNTS_URL,
            indents: companyType === SEEKER_VALUE ? SEEKER_INDENT_URL : PROVIDER_INDENT_URL,
        };

        const redirectUrl = SCLEN_URLS[type];
        if (redirectUrl) {
            localStorage.setItem('teg-component', true);
            location.href = redirectUrl;
        }
    }



    handleOnClickForTransportationRequests = () => {
        const { history } = this.props;
        history.push('/contracting/generic/transportationRequests')
    }

    handleOnClickForsupplierDashboard = () => {
        const { history } = this.props;
        history.push('/contracting/generic/supplierDashboard')
    }

    handleOnClickForsupplierPO = () => {
        const { history } = this.props;
        history.push('/contracting/generic/orders/2');
    }

    shouldRenderTransportationRequests = () => {
        const C1 = isDesmet()
        const C2 = !isDesmetSupplier()
        if (C1 && C2) {
            return true
        }
        return false
    }
    getSecondaryContractLabel = () => {
        let sLabel = 'Secondary Contracts';
        if (isEmami()) {
            sLabel = 'Dedicated Contracts';
        }
        return sLabel;
    }

    handleOnClickForReport = (report_name) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_USER_REPORT_UTILIZATION_EVENT,
            payload: {
                event_name: "on_click_of_report",
                report_name: report_name
            },
        });
    }

    handleOnClickForTransportationManagement = () => {
        const { history } = this.props;
        history.push('/transportationManagement')
    }


    render() {
        const companyType = getCompanyType();
        const isApprover = getIsApprover();
        const user = getUser();
        const actions = user.actions;
        const isAdminAccess = (actions || []).find(action => action.id == 22);
        const { rfqStatusFilter, changeRfqStatusFilter, isMenuOpen, onMenuToggle, broadcastMsgs, history } = this.props;
        return (
            <div className={`sidebar flex-column flex-middle overflowAuto pb-150 ${broadcastMsgs.length > 0 ? 'top-155' : ''}`}>
                <div className="mt-5" />
                <div className={className("sidebar-item", {
                    'active': rfqStatusFilter == 2
                })}>
                    <span className="sidebar-item-icon">
                        <HomeIcon />
                    </span>
                    <span className="sidebar-item-text ml-10 fs-14 fBold">
                        Home
                    </span>
                </div>
                {/* <div className="separator" />
                <Link to="/admin" className={className("sidebar-item", { 'active': this.props.location && this.props.location.pathname === '/admin' })}>
                    <span className="sidebar-item-icon">
                        <ListIcon />
                    </span>
                    <span className="sidebar-item-text ml-10 fs-14 fBold">Admin</span>
                </Link> */}
                {isAdminAccess && <>
                    <div className="separator" />
                    <Link to="/admin" className={className("sidebar-item", { 'active': this.props.location && this.props.location.pathname === '/admin' })}>
                        <span className="sidebar-item-icon">
                            <ListIcon />
                        </span>
                        <span className="sidebar-item-text ml-10 fs-14 fBold">Admin</span>
                    </Link>
                </>}
                <div className="separator" />
                <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })} >
                    <div onClick={() => this.collapseToggle("sourcing")} className="menu-header">
                        <a data-tip data-for='contract-source-tooltip'>
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Sourcing
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openSourcing && <span>+</span>
                                }
                                {
                                    this.state.openSourcing && <span>-</span>
                                }
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='contract-source-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                    {
                        this.state.openSourcing && <ul className="side-bar-collapsable-list pl-20 fRegular pl-5">
                            <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 2
                            })} onClick={() => changeRfqStatusFilter(2)}>Active RFQS</li>
                            {companyType === SEEKER_VALUE && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 1
                            })} onClick={() => changeRfqStatusFilter(1)}>RFQ Drafts</li>}
                            {<li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 99
                            })} onClick={() => changeRfqStatusFilter(99)}>Cancelled RFQS</li>}
                            {companyType !== SEEKER_VALUE && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 88
                            })} onClick={() => changeRfqStatusFilter(88)}>Service Category</li>}
                            {isApprover && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 10
                            })} onClick={() => changeRfqStatusFilter(10)}>Pending Approval</li>}
                            {user.isDphApprover && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 71
                            })} onClick={() => changeRfqStatusFilter(71)}>Pending DPH Approval</li>}
                            {
                                // companyType === SEEKER_VALUE &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/contractRecords'
                                }}>Contract Records</li>}
                            {companyType === SEEKER_VALUE && user.tK11Dashboard &&
                                <li className={className("fs-12 sub-menu-item", {
                                    'active': rfqStatusFilter == 11
                                })} onClick={() => changeRfqStatusFilter(11)}>TK 11 Dashboard</li>}
                            {companyType === SEEKER_VALUE && user.isCreateMasterData &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/routeMaster'
                                }}>Route Master</li>
                            }
                            {companyType === SEEKER_VALUE && isCoromandel() &&
                                < li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/dphDashboard'
                                }}>Dph Dashboard</li>
                            }

                        </ul>
                    }
                </div>
                {this.user.ammendmentLevel &&
                    <Fragment>
                        <div className="separator" />
                        <div className={className("sidebar-item pr")}>
                            <div className={className("menu-header", {
                                'active': rfqStatusFilter == 20
                            })} onClick={() => changeRfqStatusFilter(20)}>
                                <a data-tip data-for='approval-tooltip'>
                                    <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                        Approval
                                    </span>
                                </a>
                            </div>
                        </div>
                    </Fragment>}

                {DEEPAK_PHENOLICS.includes(this.user.companyId) &&
                    <Fragment>
                        <div className="separator" />
                        <div className={className("sidebar-item pr")}>
                            <div className={className("menu-header")}
                                onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/uploadPlan'
                                }}>
                                <a data-tip data-for='upload-tooltip'>
                                    <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                        Upload Plan
                                    </span>
                                </a>
                            </div>
                        </div>
                    </Fragment>}

                <div className="separator" />

                <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })}>
                    <div onClick={() => this.collapseToggle("contracting")} className="menu-header">
                        <a data-tip data-for='contract-tenture-tooltip'>
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Contracting
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openContracting && <span>+</span>
                                }
                                {
                                    this.state.openContracting && <span>-</span>
                                }
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='contract-tenture-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                    {
                        this.state.openContracting && <ul className="side-bar-collapsable-list pl-20 fRegular pl-5">
                            <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 6
                            })} onClick={() => changeRfqStatusFilter(6)}>Contracts</li>
                            <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 6
                            })} onClick={() => {
                                localStorage.setItem('teg-component', true);
                                window.location.href = LCL_URL + '/contracts'
                            }}>LCL</li>
                            {ABFRL.includes(user.companyId) &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/multiContracts'
                                }}>Multi Contracts</li>}
                            {([...PANTALOONS, ...CARGIL, ...ABFRL, ...DEEPAK_PHENOLICS_SAP, ...EMAMI,...GREEN_PLY].includes(user.companyId) || isAdaniWilmar()) &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/secondaryContracts'
                                }}>{this.getSecondaryContractLabel()}</li>}
                            <div onClick={() => {
                                const { openMultiModeContracts } = this.state;
                                this.setState({ openMultiModeContracts: !openMultiModeContracts });
                            }} className="menu-header mt-5 mb-5">
                                <span className="sidebar-item-text ml-10 fs-12 pr" >
                                    Multi Mode Contracts
                                </span>
                                <span className="collapse-button fs-14 pa fRegular" >
                                    {
                                        !this.state.openMultiModeContracts && <span>+</span>
                                    }
                                    {
                                        this.state.openMultiModeContracts && <span>-</span>
                                    }
                                </span>
                            </div>
                            {this.state.openMultiModeContracts && <>
                                <li className="sub-menu-item"><Link to="/multiModeContracts" className="fs-12 ml-10">
                                    Generate Contracts
                                </Link></li>
                                <li className="sub-menu-item"><Link to="/viewGeneratedContracts" className="fs-12 ml-10">
                                    View Generated Contracts
                                </Link></li>
                            </>}

                            {isAdaniWilmar() &&
                                <li className={className("fs-12 sub-menu-item", {
                                    'active': rfqStatusFilter == 21
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    window.location.href = '/awlMISReports'
                                }}>Reports</li>}
                            {isAdaniWilmar() &&
                                <li className={className("fs-12 sub-menu-item", {
                                    // 'active': rfqStatusFilter == 21
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    window.location.href = '/dashboards'
                                }}>Dashboards</li>}

                        </ul>
                    }
                </div>
                <div className="separator" />
                {
                    // <div className="sidebar-item pr" >
                    //     <div onClick={() => this.collapseToggle("contracting")} className="menu-header">
                    //         <span className="sidebar-item-icon">
                    //             <ListIcon />
                    //         </span>
                    //         <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                    //             TRACKING
                    //         </span>
                    //     </div>
                    // </div>   
                    // <div className="separator" />
                }
                {SHOW_SIDEBAR && companyType === SEEKER_VALUE && EMAMI.includes(user.companyId) && <React.Fragment> <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })} >
                    <div onClick={() => {
                        localStorage.setItem('teg-component', true);
                        window.location.href = '/eventManagement'
                    }} className="menu-header">
                        <a data-tip data-for='pr-tracking-tooltip'>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Event Management
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='pr-tracking-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                </div>
                    <div className="separator" /></React.Fragment>
                }

                {VISHAKA.includes(this.user.companyId) && <React.Fragment>
                    <div className={className("sidebar-item pr")}  >
                    <Link to="/cityMappingMaster" >
                        <span className="sidebar-item-text ml-10 fs-14 fBold">City Mapping Master</span>
                    </Link>
                    <div className="separator" />
                    </div>
                 </React.Fragment>
                }

                {SHOW_SIDEBAR && companyType === SEEKER_VALUE && isAdaniWilmar() && <React.Fragment> <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })} >
                    <div onClick={() => {
                        localStorage.setItem('teg-component', true);
                        history.push('/multimodalRateComparison')
                    }} className="menu-header">
                        <a data-tip data-for='pr-tracking-tooltip'>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Multimodal Comparison
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='pr-tracking-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                </div>
                    <div className="separator" /></React.Fragment>
                }
                {<React.Fragment><div className={className("sidebar-item pr", {
                        'disable': !this.user.indenting
                    })}  >
                        <div onClick={() => this.handleAccountsRedirect("indents")} className="menu-header">
                            <a data-tip data-for='indenting-tooltip'>
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Indenting
                                </span>
                            </a>
                            {!this.user.indenting && <ReactTooltip id='indenting-tooltip'>
                                <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                            </ReactTooltip>}
                            {
                                //     <span className="collapse-button fs-14 pa fRegular" >
                                //         {
                                //             !this.state.openIndenting && <span>+</span>
                                //         }
                                //         {
                                //             this.state.openIndenting && <span>-</span>
                                //         }
                                //     </span>
                            }
                        </div>

                        {
                            //     this.state.openIndenting && <ul className="side-bar-collapsable-list pl-20 fRegular">
                            //         <li className="fs-12">Active RFQS</li>
                            //         {companyType === SEEKER_VALUE &&<li className="fs-12">RFQ DRAFTS</li>}
                            //         {companyType === SEEKER_VALUE &&<li className="fs-12">CLOSED RFQS</li>}
                            //         <li className="fs-12">CONTRACTS</li>
                            //     </ul>
                        }
                    </div>
                        <div className="separator" /></React.Fragment>
                }

                {this.shouldRenderTransportationRequests() && <SiderBarElementT1
                    title={"Transportation Requests"}
                    handleOnClick={this.handleOnClickForTransportationRequests}
                />}

                {isDesmetSupplier() && <SiderBarElementT1
                    title={"Supplier Dashboard"}
                    handleOnClick={this.handleOnClickForsupplierDashboard}
                />}

                {this.shouldRenderTransportationRequests() && <SiderBarElementT1
                    title={"Supplier PO"}
                    handleOnClick={this.handleOnClickForsupplierPO}
                />}

                {TTBIL.includes(user.companyId) && <SiderBarElementT1
                    title={"Transportation Management"}
                    handleOnClick={this.handleOnClickForTransportationManagement}
                />}

                {<React.Fragment> <div className={className("sidebar-item pr", {
                        'disable': !this.user.accounts
                    })} >
                        <div onClick={() => this.handleAccountsRedirect("accounts")} className="menu-header">
                            <a data-tip data-for='accounts-tooltip'>
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                    Accounts
                                </span>
                            </a>
                            {!this.user.accounts && <ReactTooltip id='accounts-tooltip'>
                                <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                            </ReactTooltip>}
                        </div>
                    </div>
                        <div className="separator" /></React.Fragment>
                }

                {SHOW_SIDEBAR && [...HIKAL, ...BEAM].includes(user.companyId) && <React.Fragment> <div className={className("sidebar-item pr")} >
                    <div onClick={() => {
                        localStorage.setItem('teg-component', true);
                        if (isBeamS()) {   // not gave any approval , move code to prod ( if you want to use this feature please remove false )
                            history.push('/EXIMCargoTracking')
                        } else {
                            history.push('/cargoTracking')
                        }
                    }} className="menu-header">
                        <a data-tip data-for='accounts-tooltip'>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                EXIM Cargo Tracking
                            </span>
                        </a>
                        {/* {!this.user.accounts && <ReactTooltip id='accounts-tooltip'>
                                    <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                            </ReactTooltip>} */}
                    </div>
                </div>
                    <div className="separator" /></React.Fragment>
                }
                {SHOW_SIDEBAR && companyType === PROVIDER_VALUE && isAdaniWilmar(getItemFromLocal("transporter_seeker_company_id")) && <React.Fragment><div className={className("sidebar-item pr")}>
                        <div onClick={() => {
                            localStorage.setItem('teg-component', true);
                            history.push('/bookingCopy');
                            }} className="menu-header">
                            <a data-tip data-for='booking-copy-tooltip'>
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Booking Details
                                </span>
                            </a>
                        </div>
                    </div>
                    <div className="separator" /></React.Fragment>
                }

                {getIsSettingsVisible() && <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })}  >
                    <div onClick={() => this.collapseToggle("settings")} className="menu-header">
                        <a data-tip data-for='contract-settings-tooltip'>
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                Settings
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openSettings && <span>+</span>
                                }
                                {
                                    this.state.openSettings && <span>-</span>
                                }
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='contract-settings-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                    {
                        this.state.openSettings && <ul className="side-bar-collapsable-list pl-20 fRegular">
                            {companyType === SEEKER_VALUE &&
                                <Fragment>
                                    <li className="fs-12">
                                        <Link to="/groups/2" className="fs-12">TRANSPORTATION GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/8" className="fs-12">AGGREGATORS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/9" className="fs-12">SURVEYORS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/10" className="fs-12">LASHERS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/21" className="fs-12">HANDLING AGENTS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/22" className="fs-12">SHIPPING LINERS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/24" className="fs-12">BUYERS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/13" className="fs-12">CHA GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/14" className="fs-12">CFS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/27" className="fs-12">FREIGHT FORWARDER GROUP</Link>
                                    </li>
                                </Fragment>
                            }
                            {VISHAKA.includes(this.user.companyId) &&
                                <li className="fs-12">
                                    <Link to="/cityMappingMaster" className="fs-12">City Mapping Master</Link>
                                </li>
                            }
                        </ul>
                    }

                </div>}
                {getIsSettingsVisible() && <div className="separator" />}
                {!isAdaniWilmar() && !isDesmetSupplier() &&
                    // companyType === SEEKER_VALUE && 
                    <div className={className("sidebar-item pr", {
                        'disable': !this.user.reports
                    })} >
                        {this.user.reports ? <div onClick={() => this.collapseToggle("reports")} className="menu-header">
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                Reports
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openReports && <span>+</span>
                                }
                                {
                                    this.state.openReports && <span>-</span>
                                }
                            </span>
                        </div>
                            :
                            <div className="menu-header">
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Reports
                                </span>
                            </div>
                        }

                        {
                            this.state.openReports &&
                            <ul className="side-bar-collapsable-list pl-20 mb-50 fRegular">
                                {companyType === SEEKER_VALUE &&
                                    <React.Fragment>
                                        {this.state.daaiReportsLoading &&
                                            <li className="fs-12">Loading reports...</li>
                                        }
                                        {!this.state.daaiReportsLoading && this.state.DaaiReports.length === 0 &&
                                            <li className="fs-12">No reports available</li>
                                        }
                                        {!this.state.daaiReportsLoading && (this.state.DaaiReports || []).map((report) => (
                                            <React.Fragment key={`report-${report.type}`}>
                                                <Link
                                                    to={`/report/${report.type}`}
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport(report.name)
                                                    }}
                                                >
                                                    <li className="fs-12">{report.name}</li>
                                                </Link>
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                }
                                {companyType !== SEEKER_VALUE &&
                                    this.state.DaaiReports.map((report) => (
                                        <Link
                                            key={report.type}
                                            to={`/report/${report.type}`}
                                            className='fs-12'
                                            onClick={() => {
                                                this.handleOnClickForReport(report.name)
                                            }}
                                        >
                                            <li className='fs-12'>{report.name}</li>
                                        </Link>
                                    ))
                                }
                            </ul>
                        }
                    </div>}
                {companyType === SEEKER_VALUE &&
                    <div className={className("sidebar-item pr", {
                        'disable': !this.user.reports
                    })} >
                        {this.user.reports ? <div onClick={() => this.collapseToggle("dashboards")} className="menu-header">
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                Dashboards
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openDashboards && <span>+</span>
                                }
                                {
                                    this.state.openDashboards && <span>-</span>
                                }
                            </span>
                        </div>
                            :
                            <div className="menu-header">
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Dashboards
                                </span>
                            </div>
                        }

                        {
                            this.state.openDashboards &&
                            <ul className="side-bar-collapsable-list pl-20 mb-50 fRegular">
                                {this.state.daaiReportsLoading &&
                                    <li className="fs-12">Loading dashboards...</li>
                                }
                                {!this.state.daaiReportsLoading && this.state.daaiDashboards.length === 0 &&
                                    <li className="fs-12">No dashboards available</li>
                                }
                                {!this.state.daaiReportsLoading && (this.state.daaiDashboards || []).map((dashboard) => (
                                    <React.Fragment key={`dashboard-${dashboard.report_id}`}>
                                        <Link
                                            to={`/gDashboard/${dashboard.report_id}`}
                                            className="fs-12"
                                            onClick={() => {
                                                this.handleOnClickForReport(dashboard.report_name)
                                            }}
                                        >
                                            <li className="fs-12">{dashboard.report_name}</li>
                                        </Link>
                                    </React.Fragment>
                                ))}
                            </ul>
                        }
                    </div>}
                
            </div>
        )
    }
}

export default connect(null, null)(withRouter(Sidebar));
